import { render, staticRenderFns } from "./CommissionsView.html?vue&type=template&id=7b9e49ab&"
import script from "./CommissionsView.vue?vue&type=script&lang=ts&"
export * from "./CommissionsView.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionsView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports